export default {
	state: {
		navBar: {
			active: '0',
			list: []
		}
	},
	getters: {
		// 首頁
		adminIndex(state) {
			if (state.navBar.list.length === 0) {
				return 'error_404'
			}

			let item = state.navBar.list[0].submenu[0]
			//console.log(state.navBar);
			if (item) {
				return item.pathname
			}
		}
	},
	mutations: {
		// 創建菜單
		createNavBar(state, menus) {
			let list = menus.map(item => {
				let submenu = (item.child || []).map(v => {
					let thirdLevel = (v.child || []).map(i => {
						let fourthLevel = (i.child || []).map(k => {
							return {
								icon: k.icon,
								name: k.name,
								is_num: k.is_num,
								pathname: k.desc
							};
						});
		
						return {
							icon: i.icon,
							name: i.name,
							is_num: i.is_num,
							pathname: i.desc,
							child: fourthLevel // 第三级的 child 塞进去
						};
					});
		
					return {
						icon: v.icon,
						name: v.name,
						is_num: v.is_num,
						pathname: v.desc,
						child: thirdLevel // 第二级的 child
					};
				});
		
				return {
					name: item.name,
					is_num: item.is_num,
					subActive: '0',
					submenu: submenu // 一级菜单
				};
			});
		
			state.navBar.list = list;
			window.sessionStorage.setItem('navBar', JSON.stringify(state.navBar));
		},
		
		initNavBar(state) {
			let navBar = window.sessionStorage.getItem('navBar')
			navBar = navBar ? JSON.parse(navBar) : {
					active: '0',
					list: []
				},
				state.navBar = navBar
		}
	},
	actions: {

	}
}
